import { Component } from '@angular/core';

@Component({
    selector: 'app-aggrement-terms-of-service',
    templateUrl: './aggrement-terms-of-service.component.html',
    standalone: false
})
export class AggrementTermsOfServiceComponent {

}
